import type { AnchorHTMLAttributes, ReactNode } from "react";

import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text, type TextProps } from "@similarweb/ui-components/foundations";

interface IStyledTruncatedTextProps {
    direction?: "ltr" | "rtl";
}

const StyledTruncatedText = styled(Text)<IStyledTruncatedTextProps>`
    ${(props) => (props.direction ? `direction: ${props.direction};` : "")}
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colorsPalettes.blue[400]};

    & > span {
        direction: ltr;
        unicode-bidi: embed;
    }

    &:hover {
        text-decoration: underline;
    }
`;

interface ILinkProps extends Omit<TextProps, "fontVariant"> {
    children: ReactNode;
    direction?: "ltr" | "rtl";
    fontVariant?: TextProps["fontVariant"];
    href?: string;
    target?: string;
    rel?: string;
    truncate?: boolean;
}

export const Link = ({
    truncate = false,
    direction = "ltr",
    children,
    ...props
}: ILinkProps & AnchorHTMLAttributes<HTMLAnchorElement>) => {
    const onClick = (event: React.MouseEvent) => {
        event.stopPropagation();
    };

    const linkProps = {
        as: "a",
        fontVariant: "chip1",
        color: colorsPalettes.blue[400],
        cursor: "pointer",
        whenHover: {
            textDecoration: "underline",
        },
        onClick,
        ...props,
    } satisfies TextProps;

    if (truncate) {
        return (
            <StyledTruncatedText
                {...linkProps}
                direction={direction}
            >
                <span>{children}</span>
            </StyledTruncatedText>
        );
    }

    return <Text {...linkProps}>{children}</Text>;
};
